import { TranslateService } from '@ngx-translate/core';

import { epicDependencies } from '../../../../../store';
import { TranscriptBehaviourView } from '../model/transcript-behaviour-view.model';
import { TranscriptCategories } from '../model/transcript-categories.model';
import { TranscriptData } from '../model/transcript-data.model';
import { TranscriptSummaryBehaviourView } from '../model/transcript-summary-behaviour-view.model';
import { TranscriptSummaryView } from '../model/transcript-summary-view.model';
import { TranslationKeyMap } from '../transcript-summary.i18n';

// TODO move
function filterSummaryBehaviourView(
    arr: TranscriptSummaryBehaviourView[],
): TranscriptSummaryBehaviourView[] {
    return arr == null
        ? []
        : [...arr.filter((s) => s.transcripts.length > 0)].sort((a, b) =>
              (a.behaviourName ?? '').localeCompare(b.behaviourName ?? ''),
          );
}

// TODO move
export function setTranscriptCategories(
    summary: TranscriptSummaryView,
    retainState?: boolean,
    previous?: TranscriptCategories[],
): TranscriptCategories[] {
    const categories: TranscriptCategories[] = [];

    const active: TranscriptCategories = {
        label: TranslationKeyMap._10035_ACTIVE_BEHAVIORS,
        subCategories: filterSummaryBehaviourView(summary.active),
        isOpen: retainState === true ? previous?.[0]?.isOpen : true,
    };

    const draft: TranscriptCategories = {
        label: TranslationKeyMap._10036_DRAFT_BEHAVIOURS,
        subCategories: filterSummaryBehaviourView(summary.draft),
        isOpen: retainState === true ? previous?.[1]?.isOpen : false,
    };

    // TODO revise. only expect one??? only in this category???
    const noFocus = summary.nonAssociated?.find((e) => e.behaviourId == null);
    if (noFocus != null) {
        // TODO FIXME. this can be done better
        const service =
            epicDependencies.injector.get<TranslateService>(TranslateService);
        const noFocusStr: string = service.instant(
            TranslationKeyMap._10053_NO_FOCUS_SELECTED,
        );
        noFocus.behaviourName = noFocusStr;
        noFocus.behaviourNameWithCount = `${noFocusStr} (${
            noFocus.transcripts?.length ?? 0
        })`;
    }
    const unAssociated: TranscriptCategories = {
        label: TranslationKeyMap._10038_UNASSOCIATED_TRANSCRIPTS,
        subCategories: filterSummaryBehaviourView(summary.nonAssociated),
        isOpen: retainState === true ? previous?.[2]?.isOpen : false,
    };

    const closed: TranscriptCategories = {
        label: TranslationKeyMap._10037_RECENTLY_CLOSED_BEHAVIOURS,
        subCategories: filterSummaryBehaviourView(summary.closed),
        isOpen: retainState === true ? previous?.[3]?.isOpen : false,
    };

    categories.push(active, draft, unAssociated, closed);

    categories.forEach((cat) => {
        cat.count =
            cat.label === TranslationKeyMap._10038_UNASSOCIATED_TRANSCRIPTS
                ? cat.subCategories?.[0]?.transcripts?.length ?? 0
                : cat.subCategories.length;
    });

    if (retainState === true) {
        const transcripts: TranscriptData[] = [];
        previous.forEach((e) => {
            e.subCategories.reduce((p, c) => {
                p.push(...c.transcripts);
                return p;
            }, transcripts);
        });
        categories.forEach((cat) => {
            cat.subCategories.forEach((sub) => {
                sub.transcripts.forEach((ts) => {
                    ts.isOpen =
                        transcripts.find(
                            (e) => e.transcriptId === ts.transcriptId,
                        )?.isOpen ?? false;
                });
            });
        });
    }

    return categories;
}

export function setParticipants(categories: TranscriptCategories[]): string[] {
    let participants: string[] = [];

    categories.forEach((c) => {
        c.subCategories.forEach((sub) => {
            sub.transcripts.forEach((t) => {
                t.participants.forEach((p) => participants.push(p));
            });
        });
    });

    participants = participants.filter(
        (item, index, self) => self.indexOf(item) === index,
    );
    return participants;
}

export function setBehaviours(
    categories: TranscriptCategories[],
): TranscriptBehaviourView[] {
    const behaviours: TranscriptBehaviourView[] = [];

    categories.forEach((c) => {
        c.subCategories.forEach((sub) => {
            sub.transcripts.forEach((t) => {
                if (t.primaryFocus?.subBehaviourId != null) {
                    behaviours.push(t.primaryFocus);
                }
                t.behaviours.forEach((b) => {
                    if (b.behaviourId != null) {
                        behaviours.push(b);
                    }
                });
            });
        });
    });

    return behaviours.reduce<TranscriptBehaviourView[]>((p, c) => {
        if (p.every((e) => e.behaviourId !== c.behaviourId)) {
            p.push(c);
        }
        return p;
    }, []);
}

export function setSubBehaviours(
    categories: TranscriptCategories[],
): TranscriptBehaviourView[] {
    const subBehaviours: TranscriptBehaviourView[] = [];

    categories.forEach((c) => {
        c.subCategories.forEach((sub) => {
            sub.transcripts.forEach((t) => {
                if (t.primaryFocus?.subBehaviourId != null) {
                    subBehaviours.push(t.primaryFocus);
                }
                t.behaviours.forEach((b) => {
                    if (b.subBehaviourId != null) {
                        subBehaviours.push(b);
                    }
                });
            });
        });
    });

    return subBehaviours.reduce<TranscriptBehaviourView[]>((p, c) => {
        if (p.every((e) => e.subBehaviourId !== c.subBehaviourId)) {
            p.push(c);
        }
        return p;
    }, []);
}
